import { data } from 'autoprefixer';
import axios from 'axios';

export async function fetchGoogleSheetData() {
  const API_URL = 'https://sheets.googleapis.com/v4/spreadsheets/1XJlywkzYDy5qk2SU50fyss011DAlFH0TxLrbzGaorfg/values/Sheet1?key=AIzaSyAvFEjU3k501DncNZH7HvgCrnJHHqT8mZ0';

  try {
    const response = await axios.get(API_URL);
    console.log(response);
    if (response.data && Array.isArray(response.data.values)) {
      // Assume first row is headers
      const headers = response.data.values[0];
      const data = response.data.values.slice(1).map(row => {
        let rowData = {};
        if (Array.isArray(row)) {
          row.forEach((value, index) => {
            rowData[headers[index]] = value;
          });
        }
        return rowData;
      });
      return data;
    } else {
      console.error('Received data is not in expected format:', response.data.values);
      return [];
    }
  } catch (error) {
    console.error('Error fetching data from Google Sheets:', error);
    return [];
  }
}
